import { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import Icon, { IconPropsT } from './Icon';

const AllScheduleIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.0"
        width="28"
        height="28"
        viewBox="0 0 512.000000 512.000000"
        preserveAspectRatio="xMidYMid meet"
        fill={theme.colors.primary.variant1}
      >
        <g
          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
          fill="#000000"
          stroke="none"
        >
          <path d="M2315 5109 c-597 -61 -1141 -318 -1563 -739 -1002 -1000 -1002 -2620 0 -3620 406 -405 901 -648 1493 -732 119 -17 512 -16 635 1 579 80 1090 331 1489 732 406 408 649 903 733 1494 17 118 17 512 0 630 -85 593 -327 1088 -734 1495 -393 394 -891 643 -1453 726 -122 18 -477 26 -600 13z m575 -314 c897 -138 1632 -798 1854 -1666 55 -216 70 -336 70 -569 0 -302 -47 -559 -150 -820 -302 -760 -969 -1291 -1784 -1416 -140 -22 -471 -25 -605 -6 -359 51 -689 176 -974 370 -532 360 -878 909 -977 1552 -25 159 -25 481 0 640 99 643 445 1192 977 1552 322 219 661 337 1094 382 81 8 393 -4 495 -19z" />
          <path d="M1535 3296 c-146 -46 -249 -143 -304 -285 l-26 -66 -3 -567 -3 -568 155 0 156 0 0 225 0 225 150 0 150 0 0 -225 0 -225 150 0 150 0 0 539 c0 324 -4 560 -10 592 -31 164 -153 301 -311 350 -70 22 -193 24 -254 5z m195 -308 c71 -49 75 -61 78 -254 l4 -174 -151 0 -151 0 0 173 c0 154 2 175 20 205 43 70 136 93 200 50z" />
          <path d="M2410 2560 l0 -750 375 0 375 0 0 150 0 150 -225 0 -225 0 0 600 0 600 -150 0 -150 0 0 -750z" />
          <path d="M3460 2560 l0 -750 380 0 380 0 0 150 0 150 -230 0 -230 0 0 600 0 600 -150 0 -150 0 0 -750z" />
        </g>
      </svg>
    </Icon>
  );
};

export default AllScheduleIcon;
